<div class="form-container">
  <div>
    @if (!isAdmin() && cfg.appName === "ia") {
      <h1 class="ia-head">{{ i18n.langString("app_title") }}</h1>
    }
    <form nz-form [formGroup]="form" (ngSubmit)="onSubmit()">
      @for (field of formConfig(); track field.controlName) {
        @if (field.label) {
          <div class="inner-form">
            <p
              class="label-text field.label"
              [style]="
                field.controlName === FormKey.CaptchaResponse
                  ? 'visibility:hidden'
                  : 'visibility:visible'
              "
            >
              {{ field.label }}
            </p>
            <ng-template #errorTpl let-control>
              @if (true) {
                @if (control.hasError("required")) {
                  @if (field.controlName === FormKey.CaptchaResponse) {
                    <span>Captcha is required.</span>
                  } @else {
                    <span>This field is required.</span>
                  }
                }
                @if (control.hasError("email")) {
                  Please enter a valid email address.
                }
                @if (control.hasError("mismatch")) {
                  <div class="not-match">Passwords do not match.</div>
                }
              }
            </ng-template>
            <nz-form-control [nzErrorTip]="errorTpl">
              @switch (field.controlType) {
                @case ("text") {
                  <nz-input-group>
                    <input
                      type="text"
                      nz-input
                      [placeholder]="field.placeholder"
                      [formControlName]="field.controlName"
                    />
                  </nz-input-group>
                  <!-- <input
            nz-input
            [formControlName]="field.controlName"
            [id]="field.controlName"
            [placeholder]="field.placeholder || ''"
          /> -->
                  @if (field.controlName === "customerEntity") {
                    @if (!isAdmin()) {
                      <hr />
                    }
                  }
                }
                @case ("captcha") {
                  @if (
                    captchaEnabled() && field.controlName === "captchaResponse"
                  ) {
                    <app-friendly-captcha-wrapper
                      #captchaWidget
                      formControlName="captchaResponse"
                      [sitekey]="captchaSiteKey()"
                      [formFieldName]="'captchaResponse'"
                      [apiEndpoint]="'eu'"
                      [start]="'none'"
                      [theme]="'light'"
                    >
                    </app-friendly-captcha-wrapper>
                  }
                }
                @case ("number") {
                  <nz-input-number
                    [formControlName]="field.controlName"
                    [id]="field.controlName"
                    [nzPlaceHolder]="field.placeholder || ''"
                  >
                  </nz-input-number>
                }
                @case ("radio") {
                  <nz-radio-group [formControlName]="field.controlName">
                    @for (access of field.options; track access.id) {
                      <div nz-radio [nzValue]="access.id">
                        {{ access.name }}
                      </div>
                    }
                  </nz-radio-group>
                }
                @case ("select") {
                  @if (field.controlName === "country") {
                    <app-safe-select
                      [formControlName]="field.controlName"
                      [id]="field.controlName"
                      [options]="countryOptions()"
                      [placeholder]="field.placeholder || ''"
                    ></app-safe-select>
                  }
                  @if (field.controlName === "customer") {
                    <app-safe-select
                      [formControlName]="field.controlName"
                      [id]="field.controlName"
                      [options]="customerOptions()"
                      [placeholder]="field.placeholder || ''"
                    ></app-safe-select>
                  }

                  <ng-content select=".us-canada"></ng-content>
                }
                @case ("checkbox") {
                  @if (!country()) {
                    <div class="checkbox-container">
                      <button
                        type="button"
                        class="black-coral-text checkbox-button"
                        (click)="
                          checkedServiceConditions = !checkedServiceConditions
                        "
                      >
                        @if (!checkedServiceConditions) {
                          <i
                            nz-icon
                            nzType="icons:checkbox-empty"
                            class="svg-icon fillblackcoral"
                          ></i>
                        } @else {
                          <i
                            nz-icon
                            nzType="icons:status-check"
                            class="svg-icon fillblackcoral"
                          ></i>
                        }

                        <span class="icon-text">
                          {{ i18n.langString("agree_to") }}

                          <span
                            class="underline"
                            (click)="toServiceConditions()"
                          >
                            {{ i18n.langString("service_conditions") }}
                          </span>

                          <span class="icon-text">
                            {{ i18n.langString("the") }}
                          </span>

                          <span class="underline" (click)="toTermsOfUse()">
                            {{ i18n.langString("app_terms_use") }}
                          </span>

                          <span class="icon-text">
                            {{ i18n.langString("and_have_read") }}
                          </span>

                          <span
                            class="underline"
                            (click)="toDataProtectionDeclaration()"
                          >
                            {{ i18n.langString("data_protection_decalaration") }}
                          </span>
                        </span>
                      </button>
                    </div>
                  }
                  @if (country()) {
                    <div class="checkbox-container">
                      <button
                        type="button"
                        class="black-coral-text checkbox-button"
                        (click)="checkedTerms = !checkedTerms"
                      >
                        @if (!checkedTerms) {
                          <i
                            nz-icon
                            nzType="icons:checkbox-empty"
                            class="svg-icon fillblackcoral"
                          ></i>
                        } @else {
                          <i
                            nz-icon
                            nzType="icons:status-check"
                            class="svg-icon fillblackcoral"
                          ></i>
                        }

                        <span class="icon-text">
                          {{ i18n.langString("agree_to_general") }}
                          <span class="underline" (click)="toTermsOfUse()">
                            {{ i18n.langString("terms_and_conditon") }}
                          </span>
                        </span>
                      </button>

                      <button
                        type="button"
                        class="black-coral-text checkbox-button"
                        (click)="checkedDataProtection = !checkedDataProtection"
                      >
                        @if (!checkedDataProtection) {
                          <i
                            nz-icon
                            nzType="icons:checkbox-empty"
                            class="svg-icon fillblackcoral"
                          ></i>
                        } @else {
                          <i
                            nz-icon
                            nzType="icons:status-check"
                            class="svg-icon fillblackcoral"
                          ></i>
                        }

                        <span class="icon-text">
                          {{ i18n.langString("have_read") }}
                          <span
                            class="underline"
                            (click)="toDataProtectionDeclaration()"
                          >
                            {{ i18n.langString("data_protection_decalaration") }}
                          </span>
                        </span>
                      </button>
                    </div>
                  }
                }
                @case ("password") {
                  <nz-input-group [nzSuffix]="suffixTemplate">
                    <input
                      [type]="
                        passwordVisibility[field.controlName]
                          ? 'text'
                          : 'password'
                      "
                      nz-input
                      [placeholder]="field.placeholder"
                      [formControlName]="field.controlName"
                      (blur)="onBlur(field.controlName)"
                      (input)="onPasswordInput(); onInput(field.controlName)"
                    />
                  </nz-input-group>
                  @if (
                    field.controlName === "confirmPassword" &&
                    blurState["confirmPassword"]
                  ) {
                    <span class="confirm-text">Confirm your Password</span>
                  }

                  <ng-template #suffixTemplate>
                    <nz-icon
                      class="ant-input-password-icon red-alert"
                      [nzType]="
                        !isPasswordMatched() &&
                        field.controlName === 'confirmPassword'
                          ? 'icons:error-exclamation-circle'
                          : ''
                      "
                    />

                    <nz-icon
                      class="ant-input-password-icon"
                      [nzType]="
                        !passwordVisibility[field.controlName]
                          ? 'eye-invisible'
                          : 'eye'
                      "
                      (click)="
                        passwordVisibility[field.controlName] =
                          !passwordVisibility[field.controlName]
                      "
                    />
                  </ng-template>

                  @if (
                    !passwordInvalid && field.controlName === "confirmPassword"
                  ) {
                    <div class="error-content">
                      <p
                        class="fix-error"
                        [class.error-msg]="
                          passwordControl?.hasError('minlength')
                        "
                      >
                        <nz-icon
                          class="error-icons"
                          nzType="{{
                            passwordControl?.hasError('minlength')
                              ? 'close-circle'
                              : 'check-circle'
                          }}"
                          nzTheme="outline"
                        /><span class="error-display">{{
                          i18n.langString("pw_validation1")
                        }}</span>
                      </p>
                      <p
                        class="fix-error"
                        [class.error-msg]="
                          passwordControl?.hasError('noUppercase') ||
                          passwordControl?.hasError('noLowercase')
                        "
                      >
                        <nz-icon
                          class="error-icons"
                          [nzType]="
                            passwordControl?.hasError('noUppercase') ||
                            passwordControl?.hasError('noLowercase')
                              ? 'close-circle'
                              : 'check-circle'
                          "
                          nzTheme="outline"
                        ></nz-icon>

                        <span class="error-display">
                          {{ i18n.langString("pw_validation2") }}
                        </span>
                      </p>
                      <p
                        class="fix-error"
                        [class.error-msg]="passwordControl?.hasError('noDigit')"
                      >
                        <nz-icon
                          class="error-icons"
                          nzType="{{
                            passwordControl?.hasError('noDigit')
                              ? 'close-circle'
                              : 'check-circle'
                          }}"
                          nzTheme="outline"
                        /><span class="error-display">{{
                          i18n.langString("pw_validation3")
                        }}</span>
                      </p>
                      <p
                        class="fix-error"
                        [class.error-msg]="
                          passwordControl?.hasError('noSpecialChar')
                        "
                      >
                        <nz-icon
                          class="error-icons"
                          nzType="{{
                            passwordControl?.hasError('noSpecialChar')
                              ? 'close-circle'
                              : 'check-circle'
                          }}"
                          nzTheme="outline"
                        /><span class="error-display">{{
                          i18n.langString("pw_validation4")
                        }}</span>
                      </p>
                      <!-- <p
              class="fix-error"
              [class.error-msg]="passwordControl?.hasError('mismatch')"
            >
              <nz-icon
                class="error-icons"
                nzType="{{
                  passwordControl?.hasError('mismatch')
                    ? 'close-circle'
                    : 'check-circle'
                }}"
                nzTheme="outline"
              /><span class="error-display">{{ i18n.langString("pw_validation5")
              }}</span>
            </p> -->
                      <p
                        class="fix-error"
                        [class.error-msg]="
                          passwordControl?.hasError('hasWhitespace')
                        "
                      >
                        <nz-icon
                          class="error-icons"
                          nzType="{{
                            passwordControl?.hasError('hasWhitespace')
                              ? 'close-circle'
                              : 'check-circle'
                          }}"
                          nzTheme="outline"
                        /><span class="error-display">{{
                          i18n.langString("password_whitespace_validation")
                        }}</span>
                      </p>
                    </div>
                  }
                }
              }
            </nz-form-control>
          </div>
        }
      }
      <ng-content></ng-content>
      @if (!isAdmin()) {
        <nz-form-item>
          @if (formType() === "login") {
            <nz-form-control>
              <button
                id="submit-style"
                [class.invalid]="form.invalid"
                nz-button
                [disabled]="form.invalid"
              >
                <nz-icon
                  id="submit-text"
                  nzType="icons:login"
                  class="svg-icon fillwhite"
                />
                {{ this.submitText() }}
              </button>
            </nz-form-control>
          }
          @if (formType() !== "forgetPassword" && formType() !== "login") {
            <nz-form-control>
              <button
                id="submit-style"
                [class.invalid]="
                  form.invalid ||
                  (!checkedServiceConditions &&
                    !(checkedDataProtection && checkedTerms))
                "
                nz-button
                [disabled]="
                  form.invalid ||
                  (!checkedServiceConditions &&
                    !(checkedDataProtection && checkedTerms))
                "
              >
                <nz-icon
                  id="submit-text"
                  nzType="icons:login"
                  class="svg-icon fillwhite"
                />
                {{ this.submitText() }}
              </button>
            </nz-form-control>
          }
          @if (formType() === "forgetPassword") {
            <nz-form-control>
              <button
                id="submit-style"
                [class.invalid]="form.invalid || isSuccessful()"
                nz-button
                [disabled]="form.invalid || isSuccessful()"
              >
                <nz-icon
                  id="submit-text"
                  nzType="icons:forgot_password"
                  class="svg-icon fillwhite"
                />
                {{ this.submitText() }}
              </button>
            </nz-form-control>
          }
        </nz-form-item>
      }
      @if (isAdmin()) {
        <div class="access-btns">
          <button
            class="access"
            [class.disabled]="this.form.invalid"
            [disabled]="this.form.invalid"
          >
            {{ i18n.langString("grant_access") }}
          </button>
          <button class="access" (click)="showModal()">
            {{ i18n.langString("deny_access") }}
          </button>
        </div>
      }
    </form>
  </div>
  <!-- Error Template for all fields -->
</div>

<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="i18n.langString('deny_access')"
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleOk()"
  [nzFooter]="null"
  [nzMaskClosable]="false"
>
  <div class="container" *nzModalContent>
    <div class="headline">
      <h3>{{ i18n.langString("denial_reason") }}</h3>
      <p class="mandatory-text">{{ i18n.langString("required_field") }}</p>
    </div>
    <div class="text-area">
      <textarea
        id="feedback"
        name="feedback"
        rows="5"
        cols="30"
        placeholder="{{ i18n.langString('explain_text') }}"
        [(ngModel)]="denialReason"
      ></textarea>
    </div>
    <div class="deny-btn">
      <app-nav-button
        [disabled]="!denialReason"
        [primary]="true"
        (clickEvent)="deny()"
        >{{ i18n.langString("deny_access") }}
      </app-nav-button>
    </div>
  </div>
</nz-modal>
